import { H6 } from "@sellar-io/components";
import { ReactElement } from "react";
import { Dialog, DialogNavigation } from "../../../components/modal/Dialog";

import { BuyerVenueTypesDialogContent } from "./BuyerVenueTypesDialogContent";
import { BuyerVenueTypesDialogPage } from "./BuyerVenueTypesDialog.shared";

export function BuyerVenueTypesDialog({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
}): ReactElement | null {
  return (
    <Dialog
      active={active}
      className={"p-0"}
      initPage={BuyerVenueTypesDialogPage.FIRST}
      onDismiss={onDismiss}
    >
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Venue type"}
      >
        <div className="-mt-2 flex items-center justify-center">
          <H6>
            Choose <strong>up to three</strong> options
          </H6>
        </div>
      </DialogNavigation>
      <BuyerVenueTypesDialogContent onDismiss={onDismiss} />
    </Dialog>
  );
}
